module.exports = __webpack_public_path__ + "media/images/credit_points_certification_image-0e6eb7ceec9eaa8dd2394b842fc799ca.jpg";